import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";

export default function DocPreviewDialog({ doc, open, onOpenChange }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!open || !doc) return;
    let objectUrl = null;
    api.get(`/documents/${doc.id}/file`, { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); })
      .catch(() => setUrl(false));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); setUrl(null); };
  }, [open, doc]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-3xl" data-testid="doc-preview-dialog">
        <DialogHeader>
          <DialogTitle className="text-[15px]">
            {doc?.title} <span className="text-muted-foreground font-normal text-[12px] ml-2">{doc?.employee_name}</span>
          </DialogTitle>
        </DialogHeader>
        {url === null && <Skeleton className="h-96 w-full rounded-none" />}
        {url === false && (
          <p className="text-[13px] text-muted-foreground p-6">Preview unavailable for this record.</p>
        )}
        {url && (doc?.mime === "application/pdf" ? (
          <iframe title="preview" src={url} className="w-full h-[540px] border border-border" data-testid="doc-preview-frame" />
        ) : (
          <img src={url} alt="document" className="w-full max-h-[540px] object-contain border border-border" data-testid="doc-preview-image" />
        ))}
      </DialogContent>
    </Dialog>
  );
}
